export default "__VITE_ASSET__a7468a38__"